import {CircularProgress, Stack, styled} from '@mui/material';
import {toNumber} from 'lodash';
import {ComponentType, Fragment, useState} from 'react';

interface WithCircularProgressProps {
  setLoading: (loading: boolean) => void;
}

const DISPLAY = ['flex', 'none'] as const;

const ProgressContainer = styled(Stack)({
  '& .MuiCircularProgress-root': {
    margin: '0 auto',
  },
});

const Content = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'loading',
})<{loading: boolean}>(({loading}) => ({
  display: DISPLAY[toNumber(loading)],
}));

export function withCircularProgress<P extends {}>(WrappedComponent: ComponentType<P & WithCircularProgressProps>) {
  return (props: P) => {
    const [loading, setLoading] = useState(false);

    return (
      <Fragment>
        <ProgressContainer>{loading && <CircularProgress />}</ProgressContainer>
        <Content loading={loading}>
          <WrappedComponent {...props} setLoading={setLoading} />
        </Content>
      </Fragment>
    );
  };
}
